module.exports = __webpack_public_path__ + "static/media/item.f3d43724.png";